<script async setup lang="ts">
import { CULTURE } from '@/composables/helpers'
import t from '@/i18n/translations'
import { filterCount } from '@/store/filter.store'
import Button from 'primevue/button'

const props = defineProps<{
  hiddenMedia: string
}>()

const emit = defineEmits(['show-filters'])
</script>

<template>
  <div class="actions relative text-right" :class="props.hiddenMedia + ':hidden'">
    <Button size="small" class="pui-filterButton" @click="emit('show-filters')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="my-auto mr-1 size-4">
        <path
          d="M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
        />
      </svg>

      <span>{{ t(`${CULTURE}.filter.buttonLabel`) }}</span>
    </Button>
    <div class="text-2xs pui-badge absolute -right-1 -top-2 min-h-5 min-w-5 rounded-full bg-primary text-center font-bold leading-5" v-if="filterCount > 0">
      {{ filterCount }}
    </div>
  </div>
</template>
